import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SkillStandardsService } from '@app/skill-standards/services/skill-standards.service';
/**
 * TODO: This is a hacky method to get the Skill Standards Segment Status Indicator into the Flex Row Header.
 * We can remove this once we update Skill Standards to the new Flex Rows
 * The status indicator is shared with the Org Skill Standards page, which currently uses a different property for status
 * We will need to reconcile those statuses before we can get rid of this.
 * NOTE: we have access to the segment data under `row.targetResources`
 */
@Component({
  selector: 'dgx-skill-standards-segment-status-indicator-intermediary',
  templateUrl:
    './skill-standards-segment-status-indicator-intermediary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillStandardsSegmentStatusIndicatorIntermediaryComponent
  implements OnInit {
  public skillStandard;
  public status: string;
  public count: number;

  constructor(private skillStandardsService: SkillStandardsService) {}

  ngOnInit(): void {
    this.skillStandard = this.skillStandardsService.skillStandardsResponse;
    this.status = `${this.skillStandard.statusId}`;
    this.count = this.skillStandard.segments.filter(
      (s) => s.skillStandardSegmentStatusId === 0
    ).length;
  }
}
